export const BOLT_QUICK_ACTIONS_REGEX = /<bolt-quick-actions>([\s\S]*?)<\/bolt-quick-actions>/;

export type QuickActionType = 'implement' | 'message' | 'link' | 'file';

export const SUPPORTED_QUICK_ACTIONS = new Set<QuickActionType>(['implement', 'message', 'link', 'file']);

interface BaseQuickAction {
  type: QuickActionType;
  text: string;
}

interface MessageAction extends BaseQuickAction {
  type: 'implement' | 'message';
  message: string;
}

interface LinkAction extends BaseQuickAction {
  type: 'link';
  href: string;
}

interface FileAction extends BaseQuickAction {
  type: 'file';
  path: string;
}

export type QuickActionUnion = MessageAction | LinkAction | FileAction;

export type QuickActionList = QuickActionUnion[];
